<template>
  <div v-if="value.firstAid">
    <v-text-field
      v-model="value.nameFirstAid"
      :label="$t('medkitlogs.nameFirstResponder')"
      data-cy="nameFirstAid"
      :rules="requieredRule"
    ></v-text-field>
  </div>
</template>
<script>
import i18n from "../../../i18n";
export default {
  props: ["value"],
  data: () => ({ requieredRule: [(v) => !!v || i18n.t("general.fieldNeedsToBeFilled")] }),
  methods: {},
};
</script>
